const TableCellInformation = (props: any) => {
  let name = props.name ?? "";
  let email = props.email ?? "";
  return (
    <td>
      <span className="Title">{name}</span>
      <span className="Description">{email}</span>
    </td>
  )
}

export default TableCellInformation